export type Shift4Config = {
  [chainId: string]: Record<Shift4CryptoCurrencyCodeKey, string>;
};

export enum Shift4CryptoCurrencyCodeKey {
  USDC = "USDC",
  NATIVE = "NATIVE",
}
